import { useTranslation } from 'react-i18next'
import { TrashIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { exerciseName } from './planHelpers'

export function PlanWeekView({ week, onRemoveExercise, onRemoveSession }) {
  const { t, i18n } = useTranslation()

  return (
    <article className="rounded-md border border-gray-200 p-3">
      <h4 className="font-semibold text-gray-900 mb-2">
        {t('aiPlan.review.week', { number: week.week_number })}
        {week.is_deload && (
          <span className="ml-2 rounded bg-amber-100 px-2 py-0.5 text-xs text-amber-800">{t('aiPlan.review.deload')}</span>
        )}
      </h4>
      {week.days.length === 0 && <p className="text-sm text-gray-500">{t('aiPlan.review.emptyWeek')}</p>}
      <div className="space-y-3">
        {week.days.map((day) => (
          <div key={day.day_number}>
            <div className="flex items-center justify-between gap-2">
              <p className="text-sm font-medium text-gray-800">
                {day.weekday != null && `${t(`aiPlan.weekdays.${day.weekday}`)} · `}
                {i18n.language?.startsWith('de') ? day.day_name_de : day.day_name_en}
                {day.session_type && (
                  <span className="ml-2 text-xs text-gray-500">{t(`aiPlan.sessionTypes.${day.session_type}`, day.session_type)}</span>
                )}
                <span className="ml-2 text-xs text-gray-500">{t('aiPlan.review.minutes', { minutes: day.estimated_duration_minutes })}</span>
              </p>
              <button
                type="button"
                onClick={() => onRemoveSession(week.week_number, day.day_number)}
                className="text-xs text-red-600"
              >
                {t('aiPlan.review.removeSession')}
              </button>
            </div>
            <ul className="mt-1 space-y-1">
              {day.exercises.map((ex, index) => (
                <li key={`${ex.exercise_name_en}-${index}`} className="flex items-center justify-between gap-2 text-sm">
                  <span className="text-gray-700">
                    {exerciseName(ex, i18n.language)} —{' '}
                    {t('aiPlan.review.sets', { sets: ex.training_sets, reps: (ex.reps_per_set || []).join('/') })}
                    {ex.target_rpe != null && ` · ${t('aiPlan.review.rpe', { rpe: ex.target_rpe })}`}
                    {!ex.exercise_definition_id && (
                      <span className="ml-2 inline-flex items-center text-xs text-red-600">
                        <ExclamationTriangleIcon className="h-4 w-4 mr-1" />
                        {t('aiPlan.review.notInLibrary')}
                      </span>
                    )}
                  </span>
                  <button
                    type="button"
                    aria-label={t('aiPlan.review.removeExercise')}
                    onClick={() => onRemoveExercise(week.week_number, day.day_number, index)}
                    className="text-gray-400"
                  >
                    <TrashIcon className="h-4 w-4" />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </article>
  )
}
